import { ConcreteEncodable } from "./ConcreteEncodable";

import { FixingPriceEventLockResponseImplEncoder } from "../../encoder/FixingPriceEventLockResponseImplEncoder";

import * as CubiqTS from "../../index";
import { FixingPriceEventLockResponse } from "../FixingPriceEventLockResponse";

export class FixingPriceEventLockResponseImpl
  extends ConcreteEncodable
  implements FixingPriceEventLockResponse
{
  public static enType: string = "com.bcdfx.model.FixingPriceEventLockResponseImpl";

  /*FID=1*/
  public requirementId: CubiqTS.Long | null = null;
  /*FID=2*/
  public midRate: CubiqTS.BigNumber | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FixingPriceEventLockResponseImplEncoder.Instance;
    this.setEncodableType(FixingPriceEventLockResponseImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FixingPriceEventLockResponseImpl[" +
      "requirementId=" +
      this.requirementId +
      "midRate=" +
      this.midRate +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
